module.exports = __webpack_public_path__ + "static/media/85450026-RRC0wSgs.ab504710.JPG";